// extracted by mini-css-extract-plugin
export default {"container":"styles_container__1tPHJ","image":"styles_image__sDhbb","singleslide":"styles_singleslide__OPl5w"};